module.exports = __webpack_public_path__ + "assets/img/free_9.2c82792a.png";